import { observer } from 'mobx-react';
import { CheckboxItem } from '@/components/FormItem';
import FormCommon from '@/components/FormCommon';
import { useSettings } from '@/store';
import { $fm } from '@/Intl';

export default observer(() => {
  const [settings, updateSettings, defaults] = useSettings();

  return (
    <FormCommon
      initialValues={settings}
      defaults={defaults}
      onUpdate={updateSettings}
    >
      <CheckboxItem label={$fm('CONTACT_SET')} name='phonebook' />
      {/* 背景设置 */}
      <CheckboxItem label={$fm('BG_SET')} name='background' />
      {/* 布局设置 */}
      <CheckboxItem label={$fm('LAYOUT_SET')} name='layout' />
      {/* 通话设置 */}
      <CheckboxItem label={$fm('CALL_SET')} name='callset' />
      {/* 屏保设置 */}
      <CheckboxItem label={$fm('SCREEN_SAVER_SET')} name='screensaver' />
      {/* 语言与键盘 */}
      <CheckboxItem label={$fm('LANG_KEYBOARD_SET')} name='language' />
      {/* 任务栏设置 */}
      <CheckboxItem label={$fm('TASKBAR_SET')} name='taskbar' />
      {/* 屏幕自适应设置 */}
      <CheckboxItem label={$fm('AUTOSIZE_SET')} name='fitscreen' />
    </FormCommon>
  );
});
